import * as React from 'react';
import { NormalizedSearchResult } from '../../../common/d7/common';
import { SearchResultsCards } from '../../../components/search-results/search-results-card/SearchResultsCards';
import { StyledSearchResults } from '../../../components/search-results/SearchResults.styles';
import { CollectionResultsProps } from './CollectionResults.props';

const orderedSort = (nodes: NormalizedSearchResult[], order?: string[], key: string = 'id') => {
  if (order) {
    nodes.sort((a: NormalizedSearchResult, b: NormalizedSearchResult) => {
      return order.indexOf(a[key]) > order.indexOf(b[key]) ? 1 : -1;
    });
  }

  return nodes;
};

export const CollectionResults = ({ nodes, order }: CollectionResultsProps) => {
  const nodeList = orderedSort(nodes, order);
  return (
    <StyledSearchResults className='search-results-container' useTopPadding={true}>
      <SearchResultsCards results={nodeList} showBuyButtons={true} />
    </StyledSearchResults>
  );
};
